module.exports = __webpack_public_path__ + "static/media/tsukihime.620b0dda.png";